import * as React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

import './FormError.scss';

export interface FormErrorFieldProps {
  errorMessage: string;
  tooltip?: string;
}

export class FormErrorField extends React.Component < FormErrorFieldProps > {

  render() {
    return ( 
      <div className="small position-absolute invalid-tooltip">
        <span id={`tooltip-${this.props.tooltip}`}>Invalid input <FontAwesomeIcon icon={faQuestionCircle} /></span>       
        <UncontrolledTooltip placement="bottom" target={`tooltip-${this.props.tooltip}`}>
          {this.props.errorMessage}
        </UncontrolledTooltip>
      </div> 
    );
  }
}